import moment from 'moment';
import { DateType } from 'api/models';

export const isTaskDatesOutOfPhaseDateRange = (
  taskDates: [DateType | null | undefined, DateType | null | undefined],
  phaseDates: [DateType, DateType],
): boolean => {
  const [taskStartDate, taskDueDate] = taskDates;
  const [phaseStartDate, phaseDueDate] = phaseDates;
  const pStartDate = moment(phaseStartDate);
  const pDueDate = moment(phaseDueDate);

  let result = false;

  if (taskStartDate) {
    const tStartDate = moment(taskStartDate);

    result =
      tStartDate.isBefore(pStartDate, 'date') ||
      tStartDate.isAfter(pDueDate, 'date');
  }

  if (taskDueDate && !result) {
    const tDueDate = moment(taskDueDate);

    result =
      tDueDate.isAfter(pDueDate, 'date') ||
      tDueDate.isBefore(pStartDate, 'date');
  }

  return result;
};
